import React from "react";
import "./WBBLPage.css";
import WinnerTable from "./Bookmarks";
import WinnerPage from "./Winner2025";

const WBBLPage = () => {
  return (
    <>
      <div className="wbb-container">
        <div
          className="wbb-title"
          style={{ backgroundColor: "#441010ff", height: "150px" }}
        ></div>
        <WinnerPage />
      </div>
    </>
  );
};

export default WBBLPage;
